<template>
  <BaseForm
    lang="en"
    :close="handleClose"
    :open-message="handleOpenMessage"
    container-class="modal-question-form-body"
    banner-class="modal-question-form-banner"
    inputs-container-class="modal-question-form__inputs"
    checkbox-container-class="styled-checkbox"
    :translations="translations"
    :show-banner-image="true"
    :show-company-url="true"
    :show-plans-count="true"
    :show-question="true"
    :show-house-icon="true"
    form-type="demo"/>
</template>

<script setup>
import { ref } from 'vue';
import BaseForm from '@/Components/En/Modals/BaseForm.vue';

const translations = ref({
  en: {
    name_placeholder: 'Name*',
    email_placeholder: 'Email*',
    companyUrl_placeholder: 'Company website',
    plansСount_placeholder: 'Number of Floor Plans',
    privacy: 'By clicking “Submit,” I agree to the <a href="/privacy-policy" class="link" target="_blank">processing of my personal data</a>. Learn more in our <a href="/privacy-policy" class="link" target="_blank">Privacy Policy</a>',
    question_placeholder: 'Message',
    send: 'Submit Request',
    title: 'Get a Demo',
    subtitle: 'Get accurate <span class="subtitle-main">2D, 3D,</span> and <span class="subtitle-main">360° tours</span> for your property — delivered in just 24 hours.',
  },
  ru: {
    name_placeholder: 'Имя*',
    email_placeholder: 'Электронная почта*',
    companyUrl_placeholder: 'Веб-сайт компании',
    plansСount_placeholder: 'Количество планировок',
    privacy: 'Нажимая кнопку «Отправить», я даю согласие на <a href="/agreement" class="link" target="_blank">обработку персональных данных</a>. Узнать больше о <a href="/privacy-policy" class="link" target="_blank">политике конфиденциальности</a>',
    question_placeholder: 'Сообщение',
    send: 'Отправить запрос',
    title: 'Заявка на Демо',
    subtitle: 'Точные <span class="subtitle-main">2D, 3D,</span> и <span class="subtitle-main">туры 360</span> для вашей недвижимости всего за 24 часа',
  },
});
</script>
